<template>
  <div class="courseItem">
    <div class="item_bg">
      <div class="living">
        <img src="@/assets/img/icon/live.gif" alt="" />
        <span>Live</span>
      </div>
      <div class="introduce">{{ item.title }}</div>
      <img :src="filesCdnDomain + item.imageUrl" alt="" class="item_bg_img" />
    </div>
    <div class="bottom_box">
      <div class="bottom_box_left">
        <img
          :src="filesCdnDomain + item.anchor.avatar"
          alt=""
          class="avart"
          v-if="item.anchor.avatar"
        />
        <img v-else src="@/assets/img/icon/avart.png" alt="" class="avart" />
        <div class="name">{{ item.anchor.nickname }}</div>
      </div>
    </div>
  </div>
</template>
<script setup name="courseItem">
import { computed } from "vue";
import { useStore } from "vuex";
const filesCdnDomain = computed(() => store.state.commonJs.filesCdnDomain);
const store = useStore();
const props = defineProps({
  item: Object,
});
</script>
<style scoped>
.courseItem:nth-child(2n) {
  margin-right: 0;
}
.courseItem {
  width: calc((96%) / 2);
  margin-right: 2.93vw;
  margin-bottom: 2.66vw;
}
.item_bg {
  height: 24vw;
  /* background-repeat: no-repeat;
  background-size: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* padding: 1.6vw; */
  border-top-left-radius: 2.13vw;
  border-top-right-radius: 2.13vw;
  position: relative;
  overflow: hidden;
}
.item_bg_img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 24vw;
  object-fit: cover;
}
.living {
  width: 9.86vw;
  height: 4vw;
  border-radius: 2px;
  background: #1f2225;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 9;
  margin: 1.6vw 0 0 1.6vw;
}
.living img {
  width: 2.66vw;
  height: 2.66vw;
  margin-right: 2px;
}
.living span {
  color: #e0c99c;
  font-family: PingFang SC;
  font-size: 2.66vw;
  font-weight: 400;
}

.middle {
  text-align: center;
}
.lognBg {
  width: auto;
  height: 5.33vw;
}

.num_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.live_title {
  color: #fff;
  font-size: 2.93vw;
  font-weight: 400;
}
.num_box_right {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 2.93vw;
  font-weight: 500;
}
.hot {
  width: 1.6vw;
  height: 2.13vw;
}

.introduce {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 3.2vw;
  color: #fff;
  position: relative;
  z-index: 9;
  padding: 0 1.6vw 1.6vw;
  text-align: left;
}

.bottom_box {
  height: 8vw;
  border-bottom-left-radius: 2.13vw;
  border-bottom-right-radius: 2.13vw;
  background: #f3f5f6;
  padding: 0px 1.6vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottom_box_left {
  display: flex;
  align-items: center;
}
.avart {
  width: 5.33vw;
  height: 5.33vw;
  margin-right: 4px;
  border-radius: 100%;
  object-fit: cover;
}
.name {
  color: #000;
  max-width: 26vw;
  font-family: PingFang SC;
  font-size: 3.2vw;
  font-weight: 400;
  line-height: 3.73vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bottom_box_right {
  width: 12.8vw;
  height: 5.86vw;
  background-color: #d8ad6d;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: PingFang SC;
  font-size: 2.93vw;
  font-weight: 600;
  border-radius: 4px;
}
</style>
